<template>

    <Chart :type="type" :chartdata="chart" :options="options"  ></Chart>

    
</template>
<script>
import db from '@/components/firebase.init';
import Chart from '@/components/charts/Charts';
export default {
    data(){
        return{
              company_id: this.$route.params.companyId,
            chartArray: [0,0,0,0,0,0,0,0,0,0,0,0],
            type: 'line-graph',
            loaded: false,
            chart: {},                       
            options: { 
                hover: {
                    animationDuration: '1',
                },               
                animation: {
                    easing: 'easeOutCubic',
                    numSteps: '90',
                    animateScale: false,

                },
                //  progpagate:true,
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },                
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '5',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }]
                }
            },
           
        }
    },
    methods:{
        getChartData(){
            const companyId = this.company_id;
            var docRef = db.collection("companyAnalytics").doc(companyId).collection("widgetOne").doc("listing");
            docRef.get()
            .then(doc =>{

                 if(doc.exists){
 const data = doc.data();
                if(data.JAN2019 != null){
                    this.chartArray[0] = data.JAN2019;
                }
                if(data.FEB2019 != null){
                    this.chartArray[1] = data.FEB2019;
                }
                if(data.MAR2019 != null){
                    this.chartArray[2] = data.MAR2019;
                }
                if(data.APR2019 != null){
                    this.chartArray[3] = data.APR2019;
                }
                if(data.MAY2019 != null){
                    this.chartArray[4] = data.MAY2019;
                }
                if(data.JUN2019 != null){
                    this.chartArray[5] = data.JUN2019;
                }
                if(data.JUL2019 != null){
                    this.chartArray[6] = data.JUL2019;
                }
                if(data.AUG2019 != null){
                    this.chartArray[7] = data.AUG2019;
                }
                if(data.SEP2019 != null){
                    this.chartArray[8] = data.SEP2019;
                }
                if(data.OCT2019 != null){
                    this.chartArray[9] = data.OCT2019;
                }
                if(data.NOV2019 != null){
                    this.chartArray[10] = data.NOV2019;
                }
                if(data.DEC2019 != null){
                    this.chartArray[11] = data.DEC2019;
                }
                
                 }
                this.loadChart();
            })
            .catch(e =>{
                alert(e)
            })
        },
        
        loadChart(){
            this.chart = {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June','July','Aug','Sept','Oct','Nov','Dec'],
                maxHeight : [
                                1
                            ],
                datasets: [
                    
                    // {fill: 'true'},
                    
                     
                        {
                            label: '2019',
                            data: this.chartArray,
                            backgroundColor: 'rgb(219, 46, 46,.7)',
                            fill : true,
                            pointBackgroundColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            borderColor: 'white',
                            pointBorderColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            pointRadius: '5',
                            pointHitRadius: '6',
                            // pointBackgroundColor: 'rand',
                            borderWidth: '2',
                            pointBorderWidth: '3',
                            
                            
                    }
                ],
                }
                this.loaded = true;
        }
    },
    components:{
        Chart
    },
    beforeMount(){
        this.getChartData();  
    },
    
}
</script>

